/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_ADMIN_QR_TABLE = gql`
    query BatchLazyBindingParentTable(
        $criteria: filterByForBatchLazyBindingParentTable
        $skip: Int
        $limit: Int
    ) {
        batchLazyBindingParentTable(
            criteria: $criteria
            skip: $skip
            limit: $limit
        ) {
            totalCount
            data
        }

        getProducts {
            data {
                _id
                name
            }
        }
    }
`;
